import { MainContent } from "./MainContent";

export const ListViewItem = props => <MainContent {...props} />;
